import { render, staticRenderFns } from "./BtnLoadingSpinner.vue?vue&type=template&id=2f938b87&scoped=true&"
import script from "./BtnLoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./BtnLoadingSpinner.vue?vue&type=script&lang=js&"
import style0 from "./BtnLoadingSpinner.vue?vue&type=style&index=0&id=2f938b87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f938b87",
  null
  
)

export default component.exports